import styled from 'styled-components';

export const ArticleWrapper = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '80%',
    alignItems: 'center',
    textAlign: 'center',
    margin: '80px auto',
    rowGap: '40px'
});